const can = function () {
    let args = Array.prototype.slice.call(arguments, 0);
    let permissions = this.$store.state.userPermissions;
    if (permissions.length === 0) return false;
    return args.some(arg => {
        if (typeof arg === 'string') {
            arg = arg.replace('can:', '');
            let b = arg.split("*"), c = !1, d = "";
            if (1 < b.length) {
                for (let a = 0; a < b.length; a++) b[a] ? (0 < a && b[a - 1] && (d += ".*"), c = !1, d += b[a].replace(/[.*+?^${}()|[\]\\]/g, "\\$&")) : (c = !0, d += ".*");
                c || (d += ".*")
            } else d = arg;
            let regexpStr = new RegExp("^" + d + "$", "i");
            let allowed = permissions.filter(permission => regexpStr.test(permission));
            return 0 < allowed.length
        } else if (typeof arg === 'object' && arg.length > 0) {
            return can(arg)
        }
        return true;
    })
};
export default can;
